//Returns filename with extension that is found
export const extractFileTypeFromFirebasePath = (source, filename) => {
    var regex = new RegExp(filename + '.([a-zA-Z]*)?');
    let res = source.match(regex);
    return res[0] || null;
};

export const extractFileTypeFromBase64 = source => {
    let res = source.match(/data:image\/((\w)*);base64/);
    return res[1] || null;
};
